const SalesReturn = {
    salesReturnList: () => 'store/sales-return/products/search',
    salesReturnSubmit: (id:string) => `store/sales-return/product/${id}/submit`,

    salesReturnHistoryList: () => 'store/sales-return/history',
    downloadCreditNotesPdf:(id:string)=>`store/sales-return/${id}/download-credit-note`,

}
export default SalesReturn